import { inject, Injectable } from '@angular/core';
import { ErrorsHttpService } from '@qaroni-core/services/comms/errors-http/errors-http.service';
import { AccountSnackbarsService } from './account-snackbars.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AccountErrorsService {
  private errorsHttp = inject(ErrorsHttpService);
  private snackbars = inject(AccountSnackbarsService);

  public passwordError(error: HttpErrorResponse): void {
    if (this.errorsHttp.isErrorCode(error, 'E0025')) {
      this.snackbars.failureSamePassword();
    } else {
      this.snackbars.failChangePassword();
    }
  }
}
